var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.987 6.577H8.976a.9.9 0 0 0 0 1.8h13.012a.9.9 0 1 0-.001-1.8zM22.887 12.551a.9.9 0 0 0-.9-.9H8.976a.9.9 0 0 0 0 1.8h13.012a.9.9 0 0 0 .899-.9zM8.976 16.726a.9.9 0 0 0 0 1.8h6.554a.9.9 0 0 0 0-1.8z",
    fill: "#1d1c3e",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.313 29.1H5.744a1.394 1.394 0 0 1-1.392-1.392V4.292c0-.768.625-1.392 1.392-1.392H25.22c.767 0 1.392.625 1.392 1.392v8.545a.9.9 0 0 0 1.8 0V4.292A3.195 3.195 0 0 0 25.221 1.1H5.744a3.196 3.196 0 0 0-3.192 3.192v23.416A3.196 3.196 0 0 0 5.744 30.9h5.569a.9.9 0 0 0 0-1.8z",
    fill: "#1d1c3e",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.467 16.914a3.353 3.353 0 0 0-4.738 0l-8.275 8.275a1.77 1.77 0 0 0-.496.959l-.452 2.683a1.774 1.774 0 0 0 2.043 2.044l2.681-.453c.366-.061.699-.232.961-.495l8.275-8.275a3.354 3.354 0 0 0 .001-4.738zm-9.534 11.733-2.652.483.445-2.669 5.955-5.955 2.194 2.194zm8.261-8.268-1.047 1.048-2.194-2.194 1.048-1.048c.302-.302.7-.453 1.097-.453a1.55 1.55 0 0 1 1.096 2.647z",
    fill: "#1d1c3e",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotes);
export default __webpack_public_path__ + "static/media/iconNotes.25795cab4fbb3ef3e8487fe9768a98c5.svg";
export { ForwardRef as ReactComponent };